import api from "./axios";

class ServiceMovimentPesticides {
  async save(moviment) {
    const { data } = await api.post("/moviment-agrotoxico", moviment);

    return data;
  }

  async update(id, moviment) {
    await api.put(`/moviment-agrotoxico/${id}`, moviment);
  }

  async findById(id) {
    const { data } = await api.get(`/moviment-agrotoxico/${id}`);

    return data;
  }

  async delete(id) {
    await api.delete(`/moviment-agrotoxico/${id}`);
  }

  async search(
    dynamicFilters = {},
    typeMov = "",
    page = 1,
    startDate = "",
    endDate = "",
    typeOrdered = "date"
  ) {
    const { data } = await api.get("/moviment-agrotoxico", {
      params: {
        ...dynamicFilters,
        typeMov,
        page,
        startDate,
        endDate,
        typeOrdered,
      },
    });

    return data;
  }

  async sendReport(id) {
    const { data } = await api.post(
      `/moviment-agrotoxico/envia/movimentacao`,
      {
        id,
      }
    );

    return data;
  }

  async cancelReport(id) {
    const { data } = await api.post(
      `/moviment-agrotoxico/cancela/movimentacao`,
      {
        id,
      }
    );

    return data;
  }
}

export default new ServiceMovimentPesticides();
